import baseStyled, {
  useTheme as baseUseTheme,
  withTheme as baseWithTheme,
  css as baseCss,
  keyframes as baseKeyframes,
} from 'styled-components';
import type {
  ThemedCssFunction,
  ThemedStyledInterface,
} from 'styled-components';
import themeDefinition from './themeDefinitions/themeDefinition';

type ThemeColors = ReturnType<typeof themeDefinition> & {
  name: string;
};
export interface Theme {
  space: number[];
  borderRadius: string;
  inputSpace: string;
  inputLabelHeight: string;
  colors: ThemeColors;
}
const styled = baseStyled as ThemedStyledInterface<Theme>;
export default styled;

export const useTheme = baseUseTheme as () => Theme;

export const withTheme = baseWithTheme;

export const css = baseCss as ThemedCssFunction<Theme>;

export const keyframes = baseKeyframes;
